export default __webpack_public_path__ + "static/media/Key.63133626.svg";